<template lang="pug">
  .content(v-if="action")
    h2.title.is-5
      icon-base(width="30" height="30" icon-name="info" iconColor="#0567b3")
        icon-info
      | Informazioni generali
    div.wrapper
      h4(class="title is-7 action-heading") Nome intervento:
      div.action-text.text-colored {{ action['TBL_Interventi.intervento'] }}
      h4(class="title is-7 action-heading") Codice intervento:
      div.action-text.text-colored {{ action['TBL_Interventi.idPDS'] }}
      h4(class="title is-7 action-heading") Descrizione intervento:
      div.action-text {{ action['TBL_Interventi.descrizione'] }}
      h4(class="title is-7 action-heading") PdS:
      div.action-text.text-colored {{ action['TBL_Interventi.PDS'] }}
      h4(class="title is-7 action-heading") Nome azione:
      div.action-text.text-colored {{ action['Azioni.azione'] }}
      h4(class="title is-7 action-heading") Codice azione:
      div.action-text.text-colored {{ action['Azioni.idAzione'] }}
        span(v-if="action['Azioni.PDS']")  - {{ action['Azioni.PDS'] }}
      h4(class="title is-7 action-heading") Tipologia azione:
      div.action-text.text-colored {{ action['Azioni.tipologia'] }}
</template>

<script>
import IconBase from '@/components/IconBase'
import IconInfo from '@/components/icons/IconInfo'
export default {
  name: 'TheInformation',
  components: {
    IconBase,
    IconInfo
  },
  props: {
    action: {
      type: Object
    },
    idFase: {
      type: [String, Number]
    }
  },
  computed: {
    selectedActions () {
      return this.$store.getters.selectedActions(this.action)
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init () {
      // code
      this.$store.commit('SET_MAXIMIZE')
    },
    changeDisplay (display) {
      this.display = display
    }
  }
}
</script>

<style lang="scss" scoped>
h2.title {
  padding: 1em 0 1.1em 1.7em;
  background-color: lighten($background, 22%);
  margin-top: -.2em;
  margin-bottom: 2em;
  color: $link;
  font-weight: 300;
  svg {
    margin-right: .5em;
    margin-bottom: -6px;
  }
}
.wrapper {
  padding: 1em 1em 1em 2em;
}
.action-heading {
  margin-bottom: .5rem;
}
.action-text {
  font-size: .9rem;
  padding-bottom: 2rem;
  line-height: 1.3;
}

.text-colored {
  color: $link;
}

</style>



// WEBPACK FOOTER //
// src/components/TheInformation.vue